import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import {
  useChangeContractorDriverPumpPriceMutation,
  useLazyGetContractorDriverPumpPriceDetailQuery,
} from 'bus/contractorDriverPumpPrice/services';
import { ContractorDriverPumpPriceCreate } from 'bus/contractorDriverPumpPrice/types';

import { ContractorDriverPumpPriceForm } from '../../components';

type Props = {
  onRefresh: () => void;
  id: number;
  contractorId: number;
};

const PUMP_SALARY_CREATE: ContractorDriverPumpPriceCreate = {
  dateBegin: '',
  objectId: null,
  pumpLen: 0,
  minimalPumpDriverPrice: null,
  minimalPumpQuantity: null,
  pumpDriverOverPrice: null,
};

export const EditPumpSalaryModal: FC<Props> = ({ onRefresh, id, contractorId }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ContractorDriverPumpPriceCreate>(PUMP_SALARY_CREATE);

  const objectDataStore: DataSource = useMemo(() => {
    const defaultFilter = [['parentId', '=', null], 'and', ['type', '=', 1]];
    return $createDataSource(`/v1/ContractorObject/${contractorId}`, 'id', { defaultFilter });
  }, [contractorId]);

  const [getContractorDriverPumpPriceDetail] = useLazyGetContractorDriverPumpPriceDetailQuery();
  const [changeContractorDriverPumpPrice] = useChangeContractorDriverPumpPriceMutation();

  const getDriverDetail = useCallback(async () => {
    getContractorDriverPumpPriceDetail({ id })
      .unwrap()
      .then((data) => {
        if (isSuccess(data)) {
          setForm(data);
        }
      });
  }, [getContractorDriverPumpPriceDetail, id]);

  useEffect(() => {
    getDriverDetail();
  }, [getDriverDetail]);

  const handleChange = (
    name: keyof ContractorDriverPumpPriceCreate,
    value: ContractorDriverPumpPriceCreate[keyof ContractorDriverPumpPriceCreate],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    const updateData: ContractorDriverPumpPriceCreate = {
      ...form,
      id,
    };

    changeContractorDriverPumpPrice(updateData).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Ставки успешно изменена', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Редактирование ставки водителям насоса"
      visible
      isLoadingSubmit={false}
      width={600}
      height="auto"
      textConfirm="Сохранить"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <ContractorDriverPumpPriceForm form={form} onChange={handleChange} storeObject={objectDataStore} type="EDIT" />
    </ModalForm>
  );
};
